import React from 'react';

import { useTranslation } from 'react-i18next';

import { useFeatureFlags } from '@/modules/common/hooks';

/**
 * Small inline "Demo" pill rendered next to the product name in the sidebar
 * header. Renders immediately when the app is in demo mode — does not wait
 * for the trial-status API. Hidden in collapsed sidebar mode (the parent row
 * already hides itself via the [data-state=collapsed] modifier).
 */
export const DemoBadge: React.FC = () => {
  const { t } = useTranslation('common');
  const { isDemoEnv } = useFeatureFlags();

  if (!isDemoEnv) {
    return null;
  }

  return (
    <span className="inline-flex items-center rounded-lg bg-demo-banner px-2 py-1 text-xs font-semibold leading-none text-demo-banner-foreground">
      {t('demo.badge')}
    </span>
  );
};
